import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation, MediaOperationInput } from './base'
import { PanelService } from 'panel/module'

@Injectable({ providedIn: 'root' })
class ImportOp extends BaseOperation {
  icon = 'far fa-grid-2-plus'
  showInContextMenu = true
  showInAssetView = true
  showInSelectionToolbar = true
  supportsDirs = true
  supportsBundles = true
  collapseLabel = false
  weight = -99

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
  ) {
    super()
    this.label = translate.instant('Import selected')
  }

  isVisibleFor () {
    return this.panel.active
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present
  }

  async run ({ dirs, bundles }: MediaOperationInput): Promise<void> {
    await this.panel.plugin.importDirs(dirs)
    await this.panel.plugin.importBundles(bundles.filter(x => x.asset?.type !== 'fcpxml'))
    for (const bundle of bundles.filter(x => x.asset?.type === 'fcpxml')) {
      await this.panel.plugin.open(bundle)
    }
  }
}

MediaOperationsService.register(ImportOp)
